import * as React from 'react';
import ClsOverrides from './cls-overrides';
import { Dispatch, connect } from "react-redux";
import { IApplicationState, AppActionCreators, IClsOverrideResponse, CenterActionCreators } from "@nkr/store/index";
import { IClsOverrides, IBaseResponse, } from "@nkr/models/index";
import { IClsOverrideData } from './cls-overrides-data';
import { IClsOverridesRequest } from '@nkr/models/cls-overrides-request';
import { toast } from 'react-toastify';
import { RouteComponentProps } from 'react-router';

interface IOwnProps {
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getClsOverrides: (id: number) => Promise<IClsOverrideResponse>,
    saveClsOverrides: (data: IClsOverridesRequest) => Promise<IBaseResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    centerId: number,
    list: IClsOverrides
}

class CenterProfile extends React.Component<TProps, IState>{
    readonly state: IState = {
        centerId: 0,
        list: null
    }

    componentDidMount() {
        // let centerId = parseInt(this.props.match.params.id);

        // this.setState({
        //     centerId
        // }, () => {
        this.getData();
        // });
    }

    handleClsOverrideSave = (data: IClsOverrideData) => {
        let request: IClsOverridesRequest = {
            ...data,
            centerId: this.state.list.centerId
        };

        this.props.showLoading("Saving CLS Overrides, one moment please...").then(() => {
            //We need to modify this to use the passed in ID later.
            this.props.saveClsOverrides(request).then(response => {
                if (response.data.success) {
                    toast.success("CLS Overrides saved successfully");
                }

                this.props.hideLoading();
            });
        });
    }

    getData = () => {
        this.props.showLoading("Loading CLS Overrides, one moment please...").then(() => {
            this.props.getClsOverrides(this.props.centerId).then(response => {
                this.setState({
                    list: response.data.results
                });

                this.props.hideLoading();
            });
        });
    }

    render = () => {
        return (
            <div>
                {this.state.list != null && (
                    <ClsOverrides
                        data={this.state.list}
                        onSave={this.handleClsOverrideSave}
                    />
                )}
            </div>
        )
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return null;
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return ({
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { return dispatch(AppActionCreators.hideLoading()); },
        getClsOverrides: (id) => { return dispatch(CenterActionCreators.getClsOverrides(id)); },
        saveClsOverrides: (data) => { return dispatch(CenterActionCreators.saveClsOverrides(data)); },
    });
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(CenterProfile);

